<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import { Message, MessageBox } from "element-ui"
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'
    import UPDATE from '../components/page/update.vue'
    import URL from '@/views/mis/util/url'
    import Qs from 'qs'
    import axios from 'axios'
    import download from '@/utils/download'

    let status = {1: "关闭", 2: "开启"};
    let statusButton = {2: "关闭", 1: "开启"};
    let verifyType = {1: "app视频认证", 2: "人脸识别"};
    let verifyCode = {"RONGXIN": "融信", "FACEID": "FACE++"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        methods: {
            checkbox(row) {
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "modify") {
                    this.$refs.childUpdate.open(row);
                } else if (clickName == "delete") {
                    this.$axios.get(URL.face.channeldel, {
                        params:{id: row.id}
                    }).then((res)=>{
                        if (res.code == 0) {
                            this.$refs.childTable.defaultGetData(this.queryData);
                            this.$message.success(window.$t('mis.faceConfig.deleteSuccess'))
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                } else if (clickName == "switch") {
                    let status = (row.status == 1 ? 2 : 1);
                    this.$axios.get(URL.face.channelStatus, {
                        params:{id: row.id, status: status}
                    }).then((res)=>{
                        if (res.code == 0) {
                            this.$refs.childTable.defaultGetData(this.queryData);
                            this.$message.success(window.$t('mis.faceConfig.updateSuccess'))
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName || window.$t('mis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                } else if (window.$t('mis.bt.add') == clickName) {
                    this.$refs.childUpdate.open();
                } else if (window.$t('mis.faceConfig.channelExportButton') == clickName) {
                    download.exportExcel(URL.face.channelLogExport,{},window.$t('mis.faceConfig.channelExportButton')+"_"+this.parseDate(Date.now()));
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model) {
                //根据是否包含id更新还是添加
                this.dataChanage(URL.face.channelEdit, model, res => {
                    if (res.code == 0) {
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                        this.$refs.childTable.defaultGetData(this.queryData);
                    } else {

                    }
                })
            },
            dataChanage(url, option, suc, fail) {
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            },
            parseDate(date) {
                let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
                let month = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(date);
                let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
                return `${year}${month}${day}`;
            },
        },
        data() {
            return {
                deleteIds: "",
                queryData: {},
                /*新增或更新*/
                updateData: {
                    cols: [
                        {title: window.$t('mis.faceConfig.code'), field: 'code'},
                        {title: window.$t('mis.faceConfig.name'), field: 'name'},
                        {title: window.$t('mis.faceConfig.type'), field: 'type', type: 2, optionList: verifyType, isNumber: true},
                        {title: window.$t('mis.faceConfig.thirdParty'), field: 'thirdParty'},
                        {title: window.$t('mis.faceConfig.cost'), field: 'cost'},
                        {title: window.$t('mis.faceConfig.status'), field: 'status', type: 2, optionList: status, isNumber: true},
                        {title: window.$t('mis.faceConfig.remark'), field: 'remark'}
                    ]
                },
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [
                        {title: window.$t('mis.faceConfig.verifyCode'), field: 'code',type: 2, optionList: verifyCode},
                        {title: window.$t('mis.faceConfig.verifyType'), field: 'type',type: 2, optionList: verifyType, isNumber: true},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.bt.add')},
                        {click: window.$t('mis.faceConfig.channelExportButton'), auth: "cloud:face:channel:export"}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.face.channelQuery, //请求路径和参数
                    selection: true,
                    sequence: true,
                    method: "get",
                    cols: [
                        {title: window.$t('mis.faceConfig.code'), field: 'code'},
                        {title: window.$t('mis.faceConfig.name'), field: 'name'},
                        {
                            title: window.$t('mis.faceConfig.verifyTypeCN'), field: 'type', render: (data, full) => {
                                return verifyType[data] || "";
                            }
                        },
                        {title: window.$t('mis.faceConfig.describe'), field: 'remark'},
                        {title: window.$t('mis.faceConfig.thirdParty'), field: 'thirdParty'},
                        {title: window.$t('mis.faceConfig.status'), field: 'status', render: (data, full) => {
                                return status[data] || "";
                        }},
                        {title: window.$t('mis.faceConfig.statusUpdateBy'), field: 'statusUpdateBy', render: (data) => {
                                return data || "";
                        }},
                        {title: window.$t('mis.faceConfig.statusUpdateDate'), field: 'statusUpdateDate', render: (data) => {
                                return data || "";
                        }},
                        {
                            title: window.$t('mis.bt.operation'), btnClick: [{
                                name: (data, full) => {
                                    return statusButton[full.status];
                                }, click: "switch", type: "primary", icon: "el-icon-edit"
                            }, {name: window.$t('mis.bt.edit'), click: "modify", type: "primary", icon: "el-icon-edit"}, {name: window.$t('mis.bt.delete'), click: "delete", type: "primary", icon: "el-icon-delete"}]
                        },
                    ]
                }
            }
        }
    }
</script>
